import { Routes, Route } from 'react-router-dom';
import Home from './Pages/Home'
import Projects from './Pages/Projects';
import Contact from './Pages/Contact';
import Residental from './Pages/Residental';
import Multi from './Pages/Multi';
import Industrial from './Pages/Industrial';
import Layout from './Components/Layout';

function App() {
  return (
    <div>
      <Layout>
        <Routes>
          <Route path="/" element={< Home />} />
          <Route path="/realizacje" element={< Projects />} />
          <Route path="/budownictwo-mieszkalne" element={< Residental />} />
          <Route path="/budownictwo-wielorodzinne" element={< Multi />} />
          <Route path="/budownictwo-uslugowo-przemyslowe" element={< Industrial />} />
          <Route path="/kontakt" element={< Contact />} />
        </Routes>
      </Layout>
    </div>
  );
}

export default App;